import { render, staticRenderFns } from "./DoctorSideNav.vue?vue&type=template&id=7f943e14&"
import script from "./DoctorSideNav.vue?vue&type=script&lang=ts&"
export * from "./DoctorSideNav.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports